const HEADER_HEIGHT = 68;

export { HEADER_HEIGHT };
